export default function ({ boxCount, colors }, indices){
  return !(colors.some(function(color, index){
    return color.count !== indices[index]
  }));
}